"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabPanel = void 0;
const react_1 = __importStar(require("react"));
const TabsContext_1 = require("../../TabsContext");
const TabPanel_styles_1 = require("./TabPanel.styles");
/**
 * Component where the content of each tab lives
 *
 * There should be one panel per tab inside the TabList, with matching tabIds
 *
 * @deprecated please use <Ds.Tabs.Content/> instead
 * */
const TabPanel = ({ children, tabId, }) => {
    const { selectedTabId, registerTabPanel, unregisterTabPanel, getTabPanels, } = (0, TabsContext_1.useTabs)();
    (0, react_1.useEffect)(() => {
        // If removing this panel from the DOM, then unregister it from the tab context list of all panels
        return () => {
            unregisterTabPanel(tabId);
        };
    }, []);
    registerTabPanel(tabId);
    if (selectedTabId === undefined || selectedTabId !== tabId)
        return null;
    return (react_1.default.createElement(TabPanel_styles_1.StyledTabPanel, { role: "tabpanel", "aria-labelledby": tabId }, children));
};
exports.TabPanel = TabPanel;
//# sourceMappingURL=TabPanel.js.map